import axiosInstance from "../../../api/axiosInstance";
import profileImages from "../../../images/profile-*.png";

const state = {
  authHeaders: null,
  user: {
    id: null,
    username: null,
    email: null,
  },
  trueUser: {},
  users: [],
};
const getters = {
  users(state) {
    return state.users;
  },
  trueUser(state) {
    return state.trueUser;
  },
  isImpersonating(state) {
    return state.trueUser?.id && state.user?.id && state.trueUser.id !== state.user.id;
  },
  isAdmin(state) {
    return (
      state.trueUser &&
      (state.trueUser.role === "company_admin" ||
        state.trueUser.role === "super_admin" ||
        state.trueUser.role_type === "company_admin" ||
        state.trueUser.role_type === "super_admin")
    );
  },
  isSchoolAdmin(state) {
    return state.user?.role === "school_admin";
  },
  user(state) {
    return state.user;
  },
  getAuthHeaders(state) {
    return state.authToken;
  },
  getUserEmail(state) {
    return state.user?.email;
  },
  getUserID(state) {
    return state.user?.id;
  },
  isLoggedIn(state) {
    const loggedOut =
      state.authHeaders == null || state.authHeaders == JSON.stringify(null);
    return !loggedOut;
  },
  userImage(state) {
    if (!state.user?.plan_preferences?.character) return profileImages["ava"];

    try {
      return profileImages[state.user.plan_preferences.character];
    } catch (error) {
      return profileImages["ava"];
    }
  },
};
const actions = {
  updateUser({ commit }, payload) {
    return axiosInstance
      .put(`/users/${state.user.id}`, payload)
      .then((response) => {
        commit("setUserInfo", { data: { ...state.user, ...payload } });
        return response;
      });
  },
  deleteAccount({}, payload) {
    return axiosInstance.delete(`/users/${state.user.id}`, { params: payload });
  },
  registerUser({ commit }, payload) {
    return axiosInstance
      .post("/signup", { user: payload })
      .then((response) => {
        commit("setUserInfo", response.data);
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  },
  loginUser({ commit }, payload) {
    return axiosInstance
      .post("/sign_in", { user: payload })
      .then((response) => {
        commit("setUserInfo", response.data);
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  },
  logoutUser({ commit }) {
    return axiosInstance
      .delete("/sign_out")
      .then(() => {
        commit("resetUserInfo");
        return response;
      })
      .catch((error) => {
        commit("resetUserInfo");
        return error.response;
      });
  },
  loginUserWithToken({ commit }) {
    return axiosInstance
      .get("users/validate_token")
      .then((response) => {
        commit("setUserInfo", response.data);
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  },
  resetPassword({ commit }, payload) {
    return axiosInstance
      .post("/password", { user: payload })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  },
  updatePassword({ commit }, payload) {
    return axiosInstance
      .put("/password", { user: payload })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      });
  },
  impersonateUser({ commit }, userId) {
    return axiosInstance
      .post(`/impersonate`, { user_id: userId })
      .then((response) => {
        return response;
      });
  },
  stopImpersonatingUser({ commit }) {
    return axiosInstance.post(`/stop_impersonating`).then((response) => {
      return response;
    });
  },
  loadUsers({ commit }, { query }) {
    return axiosInstance
      .get(`/users`, { params: { query } })
      .then((response) => {
        commit("setUsers", response.data.users);
        return response;
      });
  },
};
const mutations = {
  setUserInfo(state, data) {
    state.user = data?.data || {
      id: null,
      username: null,
      email: null,
      plan_preferences: {},
      payment_details: {},
    };
    state.trueUser = data?.true_user || data?.data || {};
  },
  resetUserInfo(state) {
    state.user = {
      id: null,
      username: null,
      email: null,
      plan_preferences: {},
      payment_details: {},
    };
    state.trueUser = {};
    state.authHeaders = null;
    localStorage.removeItem("authHeaders");
  },
  setUsers(state, users) {
    state.users = users;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
